import { render, staticRenderFns } from "./CollectionCreatorFooterButtons.vue?vue&type=template&id=4e819ac4"
import script from "./CollectionCreatorFooterButtons.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionCreatorFooterButtons.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports